import React from 'react'
import i18n from 'common/util/internationalization'
import { DOCUMENT_STATUS, PREGENERATION_DOCUMENT_STATUS } from '../components/InvitationView/types'
import ToastErrorIcon from 'assets/icons/ToastErrorIcon'
import SuccessIcon from 'assets/icons/SuccessIcon'
import WarningAlertIcon from 'assets/icons/WarningAlertIcon'
import { Link } from './PregeneratedMinutesStyles'
import styled from '@emotion/styled'
import {
    updatePregenerationAIMinutes,
    updateTranscriptAIMinutes
} from 'businesslayer/networkrequests'
import applicationRouter from 'businesslayer/applicationRouter'
import { getLocalStorageItem } from 'businesslayer/minutesLocalStore'
import { getLocalizedLanguage } from 'common/util/langMap'
import { getTtmUrl } from 'common/util/urlMap'

const TitleLink = styled('a')<{ status: string }>`
    color: ${({ status }) => {
        if (
            status === PREGENERATION_DOCUMENT_STATUS.AUTOMATED ||
            status === PREGENERATION_DOCUMENT_STATUS.PROGRESS
        ) {
            return '#05704B'
        } else if (
            status === PREGENERATION_DOCUMENT_STATUS.PARTIAL_SUCCESS ||
            status === PREGENERATION_DOCUMENT_STATUS.NO_SECTION
        ) {
            return '#935206'
        } else {
            return '#AF292E'
        }
    }};
    font-weight: 600;
    padding-top: 16px;
    text-decoration: none;
`

const HelpCentre = styled('a')`
    color: #455d82;
    font-weight: 600;
    text-decoration: none;
`
interface Props {
    currentMinuteItem: any
    removeToast: (id: string) => void
    updateTranscriptGeneration: (status: string) => void
    updateGeneration: (status: string) => void
    toast: any
    documentStatus: string
    forTranscript: boolean
}

class UtilityHandleToast extends React.Component<Props> {
    UtilityHandleToast = () => {
        const { toast, documentStatus, forTranscript } = this.props
        switch (toast?.status) {
            case PREGENERATION_DOCUMENT_STATUS.AUTOMATED:
                return forTranscript
                    ? this.showTranscriptToast(toast, forTranscript)
                    : this.showPregenToast(toast)
            case PREGENERATION_DOCUMENT_STATUS.UNAPPROVED_ERROR:
                return forTranscript
                    ? this.showTranscriptToast(toast, forTranscript)
                    : this.showPregenToast(toast)
            case PREGENERATION_DOCUMENT_STATUS.PARTIAL_SUCCESS:
                return documentStatus === DOCUMENT_STATUS.DRAFT
                    ? forTranscript
                        ? this.showTranscriptToast(toast, forTranscript)
                        : this.showPregenToast(toast)
                    : null
            case PREGENERATION_DOCUMENT_STATUS.FAILED:
                return documentStatus === DOCUMENT_STATUS.DRAFT
                    ? forTranscript
                        ? this.showTranscriptToast(toast, forTranscript)
                        : this.showPregenToast(toast)
                    : null
            case PREGENERATION_DOCUMENT_STATUS.SUMMARY_FAILED:
                return documentStatus === DOCUMENT_STATUS.DRAFT ? this.showPregenToast(toast) : null
            case PREGENERATION_DOCUMENT_STATUS.COMPLETE_MISMATCH:
                return documentStatus === DOCUMENT_STATUS.DRAFT
                    ? forTranscript
                        ? this.showTranscriptToast(toast, forTranscript)
                        : this.showPregenToast(toast)
                    : null
            case PREGENERATION_DOCUMENT_STATUS.NO_SECTION:
                return documentStatus === DOCUMENT_STATUS.DRAFT
                    ? forTranscript
                        ? this.showTranscriptToast(toast, forTranscript)
                        : this.showPregenToast(toast)
                    : null
            default:
                return null
        }
    }

    showPregenToast = (toast: any) => {
        const message = i18n.t(toast.statusMessage)
        return toast?.author_id === toast.current_user_id &&
            toast &&
            (toast.view_toast === true ||
                (toast.id === this.props.currentMinuteItem?.id &&
                    (toast.status === PREGENERATION_DOCUMENT_STATUS.UNAPPROVED_ERROR ||
                        toast.status === PREGENERATION_DOCUMENT_STATUS.FAILED ||
                        toast.status === PREGENERATION_DOCUMENT_STATUS.PARTIAL_SUCCESS ||
                        toast.status === PREGENERATION_DOCUMENT_STATUS.SUMMARY_FAILED) &&
                    toast.view_toast === false)) ? (
            <div className={`custom-toast ${toast.status}`}>
                <div className="custom-toast-header">
                    <span className="custom-toast-icon">
                        {toast.status === PREGENERATION_DOCUMENT_STATUS.UNAPPROVED_ERROR ? (
                            <ToastErrorIcon />
                        ) : toast.status === PREGENERATION_DOCUMENT_STATUS.FAILED ? (
                            <ToastErrorIcon />
                        ) : toast.status === PREGENERATION_DOCUMENT_STATUS.SUMMARY_FAILED ? (
                            <ToastErrorIcon />
                        ) : toast.status === PREGENERATION_DOCUMENT_STATUS.PARTIAL_SUCCESS ? (
                            <WarningAlertIcon />
                        ) : (
                            <SuccessIcon />
                        )}
                    </span>
                    <div style={{ flexDirection: 'column' }}>
                        <div className={`custom-toast-title ${toast.status}`}>
                            <TitleLink
                                href={`/taker/${toast.id}`}
                                target="blank"
                                status={toast.status}>
                                {toast.MinutesTitle}
                            </TitleLink>
                        </div>
                        <div className="custom-toast-message">{message}</div>
                    </div>
                </div>
                <hr className="custom-toast-border" />
                <div className="custom-toast-buttons">
                    <button
                        className="dismiss"
                        onClick={() => {
                            if (
                                toast.id === this.props.currentMinuteItem?.id &&
                                (toast.status === PREGENERATION_DOCUMENT_STATUS.UNAPPROVED_ERROR ||
                                    toast.status === PREGENERATION_DOCUMENT_STATUS.FAILED ||
                                    toast.status ===
                                        PREGENERATION_DOCUMENT_STATUS.PARTIAL_SUCCESS ||
                                    toast.status === PREGENERATION_DOCUMENT_STATUS.SUMMARY_FAILED)
                            ) {
                                updatePregenerationAIMinutes(
                                    toast.id,
                                    PREGENERATION_DOCUMENT_STATUS.ACKNOWLEDGED,
                                    false
                                )
                            }
                            this.props.removeToast(toast.id)
                        }}>
                        {i18n.t('TOAST_DISMISS_BUTTON')}
                    </button>
                    {toast.id !== this.props.currentMinuteItem?.id && (
                        <button
                            className="action"
                            onClick={() => {
                                if (
                                    toast.id === this.props.currentMinuteItem?.id &&
                                    (toast.status ===
                                        PREGENERATION_DOCUMENT_STATUS.UNAPPROVED_ERROR ||
                                        toast.status === PREGENERATION_DOCUMENT_STATUS.FAILED ||
                                        toast.status ===
                                            PREGENERATION_DOCUMENT_STATUS.PARTIAL_SUCCESS ||
                                        toast.status ===
                                            PREGENERATION_DOCUMENT_STATUS.SUMMARY_FAILED)
                                ) {
                                    this.props.updateGeneration(
                                        PREGENERATION_DOCUMENT_STATUS.ACKNOWLEDGED
                                    )
                                }
                                applicationRouter.navigateTo(`/taker/${toast.id}`)
                            }}>
                            <Link
                                style={{ textDecoration: 'none' }}
                                href={`/taker/${toast.id}`}
                                target="blank">
                                {i18n.t('VIEW')}
                            </Link>
                        </button>
                    )}
                </div>
            </div>
        ) : null
    }

    showTranscriptToast = (toast: any, forTranscript) => {
        const message = i18n.t(toast.statusMessage)
        let userLang = getLocalStorageItem('userLanguage') || 'en'
        const localizedLang = getLocalizedLanguage(userLang)

        return toast?.author_id === toast.current_user_id &&
            toast &&
            ((toast.view_toast === true &&
                !(forTranscript && toast.status === PREGENERATION_DOCUMENT_STATUS.AUTOMATED)) ||
                (toast.id === this.props.currentMinuteItem?.id &&
                    (toast.status === PREGENERATION_DOCUMENT_STATUS.UNAPPROVED_ERROR ||
                        toast.status === PREGENERATION_DOCUMENT_STATUS.FAILED ||
                        toast.status === PREGENERATION_DOCUMENT_STATUS.PARTIAL_SUCCESS ||
                        toast.status === PREGENERATION_DOCUMENT_STATUS.COMPLETE_MISMATCH ||
                        toast.status === PREGENERATION_DOCUMENT_STATUS.NO_SECTION) &&
                    toast.view_toast === false)) ? (
            <div className={`custom-toast-ttm ${toast.status}`}>
                <div className="custom-toast-header">
                    <span className="custom-toast-icon">
                        {toast.status === PREGENERATION_DOCUMENT_STATUS.UNAPPROVED_ERROR ? (
                            <ToastErrorIcon />
                        ) : toast.status === PREGENERATION_DOCUMENT_STATUS.FAILED ? (
                            <ToastErrorIcon />
                        ) : toast.status === PREGENERATION_DOCUMENT_STATUS.COMPLETE_MISMATCH ? (
                            <ToastErrorIcon />
                        ) : toast.status === PREGENERATION_DOCUMENT_STATUS.PARTIAL_SUCCESS ? (
                            <WarningAlertIcon />
                        ) : toast.status === PREGENERATION_DOCUMENT_STATUS.NO_SECTION ? (
                            <WarningAlertIcon />
                        ) : (
                            <SuccessIcon />
                        )}
                    </span>
                    <div style={{ flexDirection: 'column' }}>
                        <div className={`custom-toast-title-ttm ${toast.status}`}>
                            <TitleLink
                                href={`/taker/${toast.id}`}
                                target="blank"
                                status={toast.status}>
                                {toast.MinutesTitle}
                            </TitleLink>
                        </div>
                        <div className="custom-toast-message">{message}</div>
                        <div>
                            {(toast.status === PREGENERATION_DOCUMENT_STATUS.PARTIAL_SUCCESS ||
                                toast.status ===
                                    PREGENERATION_DOCUMENT_STATUS.COMPLETE_MISMATCH) && (
                                <HelpCentre href={getTtmUrl(localizedLang)} target="blank">
                                    {i18n.t('HELP_CENTRE')}
                                </HelpCentre>
                            )}
                        </div>
                    </div>
                </div>
                <hr className="custom-toast-border" />
                <div className="custom-toast-buttons">
                    <button
                        className="dismiss"
                        onClick={() => {
                            if (
                                toast.id === this.props.currentMinuteItem?.id &&
                                (toast.status === PREGENERATION_DOCUMENT_STATUS.UNAPPROVED_ERROR ||
                                    toast.status === PREGENERATION_DOCUMENT_STATUS.FAILED ||
                                    toast.status ===
                                        PREGENERATION_DOCUMENT_STATUS.PARTIAL_SUCCESS ||
                                    toast.status ===
                                        PREGENERATION_DOCUMENT_STATUS.COMPLETE_MISMATCH)
                            ) {
                                updateTranscriptAIMinutes(
                                    toast.id,
                                    PREGENERATION_DOCUMENT_STATUS.ACKNOWLEDGED,
                                    false
                                )
                            }
                            this.props.removeToast(toast.id)
                        }}>
                        {i18n.t('TOAST_DISMISS_BUTTON')}
                    </button>
                    {toast.id !== this.props.currentMinuteItem?.id && (
                        <button
                            className="action"
                            onClick={() => {
                                if (
                                    toast.id === this.props.currentMinuteItem?.id &&
                                    (toast.status ===
                                        PREGENERATION_DOCUMENT_STATUS.UNAPPROVED_ERROR ||
                                        toast.status === PREGENERATION_DOCUMENT_STATUS.FAILED ||
                                        toast.status ===
                                            PREGENERATION_DOCUMENT_STATUS.PARTIAL_SUCCESS)
                                ) {
                                    this.props.updateTranscriptGeneration(
                                        PREGENERATION_DOCUMENT_STATUS.ACKNOWLEDGED
                                    )

                                    applicationRouter.navigateTo(`/taker/${toast.id}`)
                                }
                            }}>
                            <Link
                                style={{ textDecoration: 'none' }}
                                href={`/taker/${toast.id}`}
                                target="blank">
                                {i18n.t('VIEW')}
                            </Link>
                        </button>
                    )}
                </div>
            </div>
        ) : (
            forTranscript &&
                toast.status === PREGENERATION_DOCUMENT_STATUS.AUTOMATED &&
                toast.view_toast === true && (
                    <div className={`custom-toast ${toast.status}`}>
                        <div className="custom-toast-header">
                            <div style={{ display: 'flex' }}>
                                <span className={`custom-toast-icon ${toast.status}`}>
                                    <SuccessIcon />
                                </span>
                                <div className="custom-toast-message">{message}</div>
                            </div>
                            <div className="custom-toast-buttons">
                                <button
                                    className="dismiss"
                                    onClick={() => {
                                        this.props.removeToast(toast.id)
                                    }}>
                                    {i18n.t('TOAST_DISMISS_BUTTON')}
                                </button>
                            </div>
                        </div>
                    </div>
                )
        )
    }

    render() {
        return this.UtilityHandleToast()
    }
}

export default UtilityHandleToast
